/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.3.0-nightly.2026.5.31",
    versionName: "0.3.0-nightly.2026.5.31",
    versionChannel: "nightly",
    buildDate: "2026-05-31T00:35:56.037Z",
    commitHash: "eef6e6b77fc6de5a458a66b79e763c3ee796dc02",
};
